import InstagramPostsService from "@apps/instagram/services/InstagramPostsService";
import InstagramPostsResponseEntity from "@apps/instagram/services/InstagramPostsService/entities/InstagramPostsResponseEntity";
import { GetPostsRequestParamsDTO } from "@apps/instagram/services/InstagramPostsService/InstagramPostsService";
import InstagramPostsServiceInterface from "@apps/instagram/services/InstagramPostsService/InstagramPostsServiceInterface";
import { Observable } from "rxjs";

class InstagramPostsServiceMainOrInstagramPageAdapter
    implements InstagramPostsServiceInterface
{
    constructor(private readonly instagraPostsService: InstagramPostsService) {}

    checkParams(reqParams: GetPostsRequestParamsDTO): void {
        if (!reqParams.galleryId) {
            throw new Error("galleryId is required in reqParams");
        }
        if (reqParams.productIds) {
            throw new Error("productIds in not expected in reqParams");
        }
    }

    getPosts(
        reqParams: GetPostsRequestParamsDTO
    ): Observable<InstagramPostsResponseEntity> {
        this.checkParams(reqParams);
        return this.instagraPostsService.getPosts({
            ...reqParams,
        });
    }

    loadMorePosts(
        reqParams: GetPostsRequestParamsDTO
    ): Observable<InstagramPostsResponseEntity> {
        this.checkParams(reqParams);
        return this.instagraPostsService.loadMorePosts({
            ...reqParams,
        });
    }
}

export default InstagramPostsServiceMainOrInstagramPageAdapter;
